import { React } from 'react';
import { Container } from 'react-bootstrap';
import { Password } from './Password/Password';
import { useUserContext } from 'contexts/UserContext';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function ResetPassword() {
    const { t } = useTranslation();
    const { userData, updateUser } = useUserContext();
    const navigate = useNavigate();
    const handleReseted = () => {
        updateUser({
            ...userData,
            resetPassword: 0
        });
        navigate('/home');
    };
    if (!userData) return null;

    return (
        <Container className="mt-4" style={{ maxWidth: '480px' }}>
            <h2>{t('prResetPassword')}</h2>
            <Password handleReseted={handleReseted}></Password>
        </Container>
    );
}
